import { render, staticRenderFns } from "./ProvidersList.vue?vue&type=template&id=50808cf6&scoped=true&"
import script from "./ProvidersList.vue?vue&type=script&lang=js&"
export * from "./ProvidersList.vue?vue&type=script&lang=js&"
import style0 from "./ProvidersList.vue?vue&type=style&index=0&id=50808cf6&lang=scss&scoped=true&"
import style1 from "./ProvidersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50808cf6",
  null
  
)

export default component.exports